import {ShapeCommand} from '../commands.template';

export class FlowlineChangeStyleCommand extends ShapeCommand {
  services: any;
  firstAction;
  boolean;
  reverseStyleChange: any;
  constructor(data) {
    super(data);
    this.firstAction = true;
  }

  prepareData() {
    const flowlineJson = this.services.jsonHandlerSvc.get().flowlines.find(f => {
      return Number(f.mxKey) === Number(this.object.mxKey);
    });

    this.reverseStyleChange = {
      mxKey: flowlineJson.mxKey,
      style: flowlineJson.style,
      customStyle: flowlineJson.customStyle
    };

    return this;
  }

  public execute() {
    super.execute();

    return this.sendChanges(this.object);
  }

  public reverse() {
    super.reverse();

    return this.sendChanges(this.reverseStyleChange);
  }

  private sendChanges(styleChange) {
    const mxStyles = ['strokeColor', 'strokeWidth', 'fontColor', 'shadow', 'fontFamily'];
    const ourStyles = ['lineColor', 'lineWidth', 'fontColor', 'shadow', 'font'];

    this.services.graphHelperSvc.mxStyleApply(
      mxStyles,
      ourStyles,
      styleChange.mxKey,
      styleChange.customStyle,
      styleChange.style,
      'flowline'
    );

    const action: any = {
      changeFlowline: {
        mxKey: styleChange.mxKey,
        customStyle: styleChange.customStyle
      }
    };

    if (styleChange.customStyle) {
      action.changeFlowline.style = styleChange.style;
    }

    this.services.diagramUpdateSvc.update(action);
  }
}
